import styled from "styled-components";
import { BLUE } from "@root/common";

const UpperInfoStyled = styled.div`
    position: relative;
    height: 50%;
    width: 100%;
    padding: 2.5%;
    padding-top: 0;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5%;
`

const TitlesContainer = styled.div`
    height: calc(100% / 4);
    position: relative;
    width: 100%;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 0 4%;
`

const InfoSettings = styled.div`
  width: 48%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1em;

  p {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;

    input {
        width: calc(100% - 6em);
        border-radius: 8px;
        outline: none;

        margin-left: 1em;
        padding: 6px;

        &:focus {
            border: 1px solid black;
        }

        appearance: none;
        margin: 0;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* for firefox */
    input[type=number]{
      -moz-appearance: textfield;
    }
  }
`

const Info = styled.div`
  height: auto;

  padding: 1em .25em;
  border: 1px solid;
  border-radius: 1em;
  width: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  p {
    white-space: nowrap;
  }
`

const LongShortContainer = styled.div`
    height: calc(100% * 3 / 4);
    width: 100%;

    display: flex;
    flex-direction: row;
    gap: 0 4%;
    flex-wrap: wrap;

    #linksArray {
      font-size: 1em;

      @media (max-width: 1450px) {
        font-size: .9em;
      }

      @media (max-width: 900px) {
        font-size: 1em;
      }

      @media (max-width: 525px) {
        font-size: .8em;
      }

      @media (max-width: 420px) {
        font-size: .7em;
      }
    }

    div {
        width: 48%;
        height: 100%;
        padding: .5em;
        border: 1px solid black;
        border-radius: 1em;
        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        a {
            color: ${BLUE};
            text-decoration: none;
            font-size: 1.2em;
        }

        & > p, span {
            width: 100%;
            text-align: start;
            text-wrap: nowrap;
            height: 32px;

            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }
`

export {UpperInfoStyled, TitlesContainer, LongShortContainer, InfoSettings, Info}
